module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-02.44481b08.jpg";